import {AfterViewChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {LoaderService} from './service/loader.service';

import {TableExtendedService} from 'src/app/component/admin-layout/shared/crud-table';
import {NavigationEnd, Router} from '@angular/router';
import {SplashScreenService} from './component/admin-layout/controls/splash-screen/splash-screen.service';
import {Subscription} from 'rxjs';
import {FirebaseNotificationService} from './service/firebase-notification.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import { GeneralService } from 'src/app/service/general-service';
import {Constant} from './shared/constants/constant.class';
@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewChecked {
  title = 'push-notification';
  message;
  private unsubscribe: Subscription[] = [];

  constructor(
    // private messagingService: MessagingService,
    private loaderService: LoaderService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private splashScreenService: SplashScreenService,
    private tableService: TableExtendedService,
    private fcmService: FirebaseNotificationService,
    private nzNotification: NzNotificationService,
    private generalService: GeneralService,
  ) {
  }

  ngOnInit(): void {
    // Các trang public tra cứu kết quả (ket-qua-test, ket-qua, tra-cuu) không cần push
    // notification. Bỏ qua khởi tạo FCM cho các trang này vì nhiều in-app browser
    // (Zalo, Telegram, Messenger...) không hỗ trợ Push API/Notification API, gọi FCM
    // ở đây có thể làm app trắng màn hình khi mở link từ các app đó.
    if (!this.isPublicRoute()) {
      this.initFirebaseMessaging();
    }
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // clear filtration paginations and others
        this.tableService.setDefaults();
        // hide splash screen
        this.splashScreenService.hide();
        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
          document.getElementById('html').className = 'loaded';
        }, 500);

        this.tableService.setDefaults();
        // this.messagingService.requestPermission()
        // this.messagingService.receiveMessage()
        // this.message = this.messagingService.currentMessage;

      }
    });
    this.unsubscribe.push(routerSubscription);
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  // Kiểm tra route hiện tại (đọc thẳng từ window.location vì lúc ngOnInit chạy,
  // Router có thể chưa emit NavigationEnd) có phải trang public tra cứu kết quả không.
  private isPublicRoute(): boolean {
    const path = window.location.pathname || '';
    return Constant.PUBLIC_ROUTES.some(route => path.includes(`/${route}`));
  }

  private async initFirebaseMessaging(): Promise<void> {
    try {
      const token = await this.fcmService.requestPermissionAndGetToken();
      if (token) {
        const savedToken = localStorage.getItem(Constant.FIREBASE_TOKEN);
        // Chỉ gọi API khi token mới hoặc token thay đổi
        if (token !== savedToken) {
          localStorage.setItem(Constant.FIREBASE_TOKEN, token);
          this.generalService.saveToken({ token, deviceType: 'Web' }).subscribe({
            next: () => console.log('[FCM] Đã lưu token mới ✅'),
            error: (err) => console.error('[FCM] Lỗi lưu token:', err)
          });
        } else {

        }
      }

      this.fcmService.listenForegroundMessages();
      this.fcmService.message$.subscribe((payload) => {
        this.nzNotification.info(payload.title, payload.body, {
          nzDuration: 5000,
          nzPlacement: 'topRight'
        });
      });
    } catch (err) {
      // An toàn tuyệt đối: FCM lỗi không được phép làm sập cả app.
      console.error('[FCM] Bỏ qua khởi tạo push notification do lỗi:', err);
    }
  }
}
